export default __webpack_public_path__ + "static/media/close.17732063.svg";